import logo from "../../assets/images/logotalent.png";
import { AppBar, Toolbar } from "@mui/material";
import { web_url } from "../../config/config";

const LoginHeader = () => {
  return (
    <AppBar className="logo-only-header" sx={{ bgcolor: "#fff" }} position="static">
      <Toolbar>
        <a href={web_url} target="_blank" rel="noopener noreferrer">
          <img
            src={logo}
            alt="Talent Source Logo"
            style={{
              marginLeft: "10px",
              width: "150px",
              cursor: "pointer",
            }}
          />
        </a>
      </Toolbar>
    </AppBar>
  );
};

export default LoginHeader;
